export default __webpack_public_path__ + "medical-treatmentc1b1c1.jpg";